import PageHeader from '../PageHeader'
import Image from '../../images/header-process.png'

const HeaderProcess = () => {
  return (
    <PageHeader pageName="pricing" imageUrl={Image}>
        <h2 className="image-text">Let's Bring Your Perfect Ceremony to Life!</h2>
    </PageHeader>
  )
}

export default HeaderProcess